import config from "../config/config.json";
import { headers } from "../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody
} from "../APIHelpers/Responses";

export const designationServices = {
  addNewDesignation,
  updatedDesignation,
  softDeleteRestoreDesignation,
  deleteDesignation,
  getDesignationList,
  getPermissionDetails,
};

// Add New Designation
async function addNewDesignation(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewDesignation`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Update Designation
async function updatedDesignation(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updatedDesignation`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  if (!userData?.bookmarkType) {
    handleResponse(data)
  }
  return data;
}

// Soft Delete & Restore Designation
async function softDeleteRestoreDesignation(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}softDeleteRestoreDesignation`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  if (!userData?.bookmarkType) {
    handleResponse(data)
  }
  return data;
}

// Delete Designation
async function deleteDesignation(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteDesignation`,
    headersWithAuth("DELETE", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Get All Designation
async function getDesignationList(status, searchData, page, length) {
  let response
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getDesignationList/${status}?search=${searchData || ""}&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getDesignationList/${status}?search=${searchData || ""}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}
// Get All Designation
async function getPermissionDetails(designationId) {
  let response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getPermissionDetails/${designationId}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}